import card_services from "services/card_services";
import { AppDispatch, RootState } from "./store";
import { networkTypeSelector } from "./userSliceHelpers";
import { cacheMerchant } from "./userSlice";

export const fetchMerchantName =
  (address: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const existing = getState().user.merchantsMap[address];
    if (existing) return;

    const networkType = networkTypeSelector(getState());

    try {
      const merchantName = await card_services.merchantNameFromAliasAddress(
        address,
        networkType,
      );
      if (merchantName) {
        dispatch(cacheMerchant({ address, merchantName }));
      }
    } catch (error) {
      console.log("fetchMerchantName error:", error);
    }
  };
